/** Dialog exit motion shared by <Modal> (Schulportal stage). Off under prefers-reduced-motion and under the Schulportal
 *  "Bewegung" switch (data-bewegung="aus" on the document root, see school/lib/bewegung.ts). */

export const bewegungOk = (): boolean =>
  typeof window !== 'undefined' && typeof window.matchMedia === 'function' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  && !(typeof document !== 'undefined' && document.documentElement.getAttribute('data-bewegung') === 'aus')

export interface DialogAbgang { fertig: Promise<void>; abbrechen: () => void }

/** Prototype closeLayer(): the dialog scales to 0.9, drops y 20 and fades (220 ms) while the backdrop fades. Reduced motion: no animation. */
export function dialogVerlassen(huelle: Element | null, hintergrund: Element | null): DialogAbgang | null {
  if (!huelle || !bewegungOk() || typeof huelle.animate !== 'function') return null
  const opt: KeyframeAnimationOptions = { duration: 220, easing: 'cubic-bezier(0.55, 0.06, 0.68, 0.19)', fill: 'forwards' }
  const laeufe = [huelle.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(20px) scale(0.9)' }], opt)]
  // Backdrop (prototype): 0.25 s after a 0.05 s delay, GSAP default ease (power1.out).
  if (hintergrund) laeufe.push(hintergrund.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 250, delay: 50, easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)', fill: 'forwards' }))
  return {
    fertig: Promise.all(laeufe.map((a) => a.finished)).then(() => undefined, () => undefined),
    abbrechen: () => laeufe.forEach((a) => a.cancel()),
  }
}
